export default __webpack_public_path__ + "static/media/flagSpecial5.51cd0880.svg";